var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 7.5H8.75C8.06 7.5 7.5 8.06 7.5 8.75C7.5 9.44 8.06 10 8.75 10H23.75C24.44 10 25 9.44 25 8.75C25 8.06 24.44 7.5 23.75 7.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.5H8.75C8.06 12.5 7.5 13.06 7.5 13.75C7.5 14.44 8.06 15 8.75 15H18.75C19.44 15 20 14.44 20 13.75C20 13.06 19.44 12.5 18.75 12.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0H5C2.2425 0 0 2.2425 0 5V30C0 30.485 0.28 30.9275 0.72 31.1325C0.8875 31.21 1.07 31.25 1.25 31.25C1.5375 31.25 1.8225 31.15 2.05 30.96L9.2025 25H27.5C30.2575 25 32.5 22.7575 32.5 20V5C32.5 2.2425 30.2575 0 27.5 0ZM30 20C30 21.3775 28.88 22.5 27.5 22.5H8.75C8.4575 22.5 8.175 22.6025 7.95 22.79L2.5 27.3325V5C2.5 3.6225 3.62 2.5 5 2.5H27.5C28.88 2.5 30 3.6225 30 5V20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10C34.31 10 33.75 10.56 33.75 11.25C33.75 11.94 34.31 12.5 35 12.5C36.38 12.5 37.5 13.6225 37.5 15V36.1475L33.28 32.7725C33.06 32.5975 32.7825 32.5 32.5 32.5H15C13.62 32.5 12.5 31.3775 12.5 30V28.75C12.5 28.06 11.94 27.5 11.25 27.5C10.56 27.5 10 28.06 10 28.75V30C10 32.7575 12.2425 35 15 35H32.06L37.9675 39.7275C38.195 39.9075 38.4725 40 38.75 40C38.9325 40 39.1175 39.96 39.2925 39.8775C39.725 39.6675 40 39.23 40 38.75V15C40 12.2425 37.7575 10 35 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.615549269c372d60cb36eda73ce5f687.svg";
export { ForwardRef as ReactComponent };